import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{

  },
  detailButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  detailText: {
    fontSize: '12px',
    color: theme.palette.grey.grey500,
    fontWeight: 600,
    marginLeft: '11px',
    marginRight: '2px',
  },
  openDetail: {
    transform: 'rotate(180deg)',
    transition: 'transform 0.1s ease-in-out',
  },
  closeDetail: {
    transform: 'rotate(0deg)',
    transition: 'transform 0.1s ease-in-out',
  },

}));

export default useStyles;
